var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{staticClass:"mb-3",attrs:{"no-body":""}},[_vm._t("canvas"),_c('b-card-body',[_c('h5',{staticClass:"game-title"},[_vm._v(_vm._s(_vm.name))]),_c('div',{staticClass:"card-controls"},[_vm._t("controls")],2)])],2)}
var staticRenderFns = []

export { render, staticRenderFns }